<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="flex flex-wrap justify-content-end">
        <div *ngIf="machine?.model.machineType === 'ZITRUX'" class="flex">
          <span class="line-height-4 mr-1">
            <span class="text-xl font-semibold">{{'common.viewInLiters' | transloco}}</span>&nbsp;
          </span>
          <div class="mr-4 mt-1">
            <p-inputSwitch [(ngModel)]="viewInLiters" (onChange)="changeLiters($event)" [disabled]="this.isMachineLoading || this.areChartsLoading"></p-inputSwitch>
          </div>
        </div>
        <button
          [disabled]="this.isMachineLoading || this.areChartsLoading"
          [label]="'common.exportXls' | transloco"
          (click)="exportVisible = !exportVisible; exportFileType = ExportFileType.MACHINE_CHARTS"
          pButton
          class="p-button-secondary md:mr-2"
          icon="pi pi-file-excel"
        ></button>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-12 xl:col-4">
    <div class="card relative" [ngStyle]="{height: '18rem'}">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesByHourOfLastDayTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading && !this.areChartsLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsByHourOfLastDay' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersByHourOfLastDay' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading || this.areChartsLoading" width="100%"
                    height="2rem"></p-skeleton>
      </div>
      <hr>
      <div #squeezedValuesByHourOfDayDiv class="flex h-9rem">
                <span class="m-auto text-400 font-medium text-xl"
                      *ngIf="!this.areChartsLoading && this.squeezedValuesByHourOfDay.data == null">
                    {{'empty.measures' | transloco}}</span>
        <span *ngIf="!this.areChartsLoading && this.squeezedValuesByHourOfDay.data != null"
              class="m-auto text-primary font-semibold text-5xl text-center">
                    <app-generic-graph name="squeezedFruitsByHourOfDay" [dataType]="'category'"
                                       [categories]="this.squeezedValuesByHourOfDay.categories"
                                       [data]="this.squeezedValuesByHourOfDay.data"
                                       [height]="150" [width]="this.squeezedValuesByHourOfDayDivWidth"
                                       chartType="column" class="mt-3"
                                       [pointFormat]="this.tooltipFormatter(this.squeezedValuesTranslation)"
                                       [plotOptions]="plotOptions" [(update)]="updateFlag">
                    </app-generic-graph>
                </span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading || this.areChartsLoading" width="30%"
                    height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card relative" [ngStyle]="{height: '18rem'}">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesByDayOfLastWeekTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading && !this.areChartsLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsByDayOfLastWeek' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersByDayOfLastWeek' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading || this.areChartsLoading" width="100%"
                    height="2rem"></p-skeleton>
      </div>
      <hr>
      <div #squeezedValuesByDayOfWeekDiv class="flex h-9rem">
                <span class="m-auto text-400 font-medium text-xl"
                      *ngIf="!this.areChartsLoading && this.squeezedValuesByDayOfWeek.data == null">
                    {{'empty.measures' | transloco}}</span>
        <span *ngIf="!this.areChartsLoading && this.squeezedValuesByDayOfWeek.data != null"
              class="m-auto text-primary font-semibold text-5xl text-center">
                    <app-generic-graph name="squeezedFruitsByDayOfWeek" [dataType]="'category'"
                                       [categories]="this.squeezedValuesByDayOfWeek.categories"
                                       [data]="this.squeezedValuesByDayOfWeek.data"
                                       [height]="150" [width]="this.squeezedValuesByDayOfWeekDivWidth"
                                       chartType="column" class="mt-3"
                                       [pointFormat]="this.tooltipFormatter(this.squeezedValuesTranslation)"
                                       [plotOptions]="plotOptions">
                    </app-generic-graph>
                </span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading || this.areChartsLoading" width="30%"
                    height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card relative" [ngStyle]="{height: '18rem'}">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesByMonthOfLastYearTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading && !this.areChartsLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsByMonthOfLastYear' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersByMonthOfLastYear' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading || this.areChartsLoading" width="100%"
                    height="2rem"></p-skeleton>
      </div>
      <hr>
      <div #squeezedValuesByMonthOfYearDiv class="flex h-9rem">
                <span class="m-auto text-400 font-medium text-xl"
                      *ngIf="!this.areChartsLoading && this.squeezedValuesByMonthOfYear.data == null">
                    {{'empty.measures' | transloco}}</span>
        <span
          *ngIf="!this.areChartsLoading && this.squeezedValuesByMonthOfYear.data != null"
          class="m-auto text-primary font-semibold text-5xl text-center">
                    <app-generic-graph name="squeezedFruitsByMonthOfYear" [dataType]="'category'"
                                       [categories]="this.squeezedValuesByMonthOfYear.categories"
                                       [data]="this.squeezedValuesByMonthOfYear.data" [height]="150"
                                       [width]="this.squeezedValuesByMonthOfYearDivWidth" chartType="column"
                                       class="mt-3"
                                       [pointFormat]="this.tooltipFormatter(this.squeezedValuesTranslation)"
                                       [plotOptions]="plotOptions">
                    </app-generic-graph>
                </span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading || this.areChartsLoading" width="30%"
                    height="3rem"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card" [ngStyle]="{'min-height': '4.5rem'}">
      <div class="flex flex-wrap justify-content-between">
        <span class="line-height-4">
          <span class="text-xl font-semibold">{{ 'attribute.period' | transloco}}:</span>&nbsp;
          <span *ngIf="!this.isSpecificPeriodSelected" class="text-md font-medium text-primary">{{ 'misc.' +
          selectedPeriod | transloco}}</span>
          <span class="text-md font-medium text-secondary" *ngIf="this.isSpecificPeriodSelected">
              {{ 'attribute.from' | transloco }} <b>{{this.specificPeriodRange[0] | date}}</b> {{
            'attribute.until' | transloco | lowercase}}
            <b>{{this.specificPeriodRange[1]
              | date}}</b>
          </span>
        </span>
        <div class="flex flex-wrap justify-content-end">
          <button
            [disabled]="this.isMachineLoading"
            [label]="'common.exportXls' | transloco"
            (click)="exportVisible = !exportVisible; exportFileType = ExportFileType.MACHINE_CHARTS_IN_PERIOD"
            pButton
            class="p-button-secondary md:mr-2"
            icon="pi pi-file-excel"
          ></button>
          <button
            [label]="'common.filters' | transloco"
            (click)="filtersVisible = !filtersVisible"
            pButton
            class="p-button-secondary"
            icon="pi pi-sliders-h"></button>
        </div>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 xl:col-4">
        <div class="grid">
          <div class="col-12 lg:col-6 xl:col-12">
            <div class="card h-16rem relative">
              <div class="absolute top-0 left-0" pTooltip="{{'misc.info.charts.machineOperatingTime' | transloco}}"
                   tooltipPosition="top">
                <div class="info-background">
                  <i class="pi pi-info" style="font-size: 0.8rem"></i>
                </div>
              </div>
              <div class="card-header h-3rem pt-1">
                <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isPeriodChartInfoLoading">
                  {{'misc.overview.machineOperatingTime' | transloco}}
                </h4>
                <p-skeleton *ngIf="this.isPeriodChartInfoLoading" width="100%" height="2rem"></p-skeleton>
              </div>
              <hr>
              <div class="flex h-9rem">
                <span class="m-auto text-400 font-medium text-xl"
                      *ngIf="!this.isPeriodChartInfoLoading && this.operatingTime == null">
                    {{'empty.measures' | transloco}}</span>
                <span class="m-auto text-primary font-semibold text-5xl text-center"
                      *ngIf="!this.isPeriodChartInfoLoading && this.operatingTime != null">
                                    {{ this.operatingTime }}</span>
                <p-skeleton class="m-auto" *ngIf="this.isPeriodChartInfoLoading" width="30%" height="3rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="col-12 lg:col-6 xl:col-12">
            <div class="card relative h-16rem">
              <div class="absolute top-0 left-0" pTooltip="{{'misc.info.charts.machineOutOfServiceTime' | transloco}}"
                   tooltipPosition="top">
                <div class="info-background">
                  <i class="pi pi-info" style="font-size: 0.8rem"></i>
                </div>
              </div>
              <div class="card-header h-3rem pt-1">
                <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isPeriodChartInfoLoading">
                  {{'misc.overview.machineOutOfServiceTime' | transloco}}
                </h4>
                <p-skeleton *ngIf="this.isPeriodChartInfoLoading" width="100%" height="2rem"></p-skeleton>
              </div>
              <hr>
              <div class="flex h-9rem">
                <span class="m-auto text-400 font-medium text-xl"
                      *ngIf="!this.isPeriodChartInfoLoading && this.outOfServiceTime == null">
                    {{'empty.measures' | transloco}}</span>
                <span class="m-auto text-primary font-semibold text-5xl text-center"
                      *ngIf="!this.isPeriodChartInfoLoading && this.outOfServiceTime != null">
                                    {{ this.outOfServiceTime }}</span>
                <p-skeleton class="m-auto" *ngIf="this.isPeriodChartInfoLoading" width="30%" height="3rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 xl:col-8">
        <div class="card relative" [ngStyle]="{height: '33rem'}">
          <div class="absolute top-0 left-0" [pTooltip]="totalSqueezedValuesInPeriodTranslation" tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isPeriodChartInfoLoading">
              <span *ngIf="!filtersViewInLiters">{{'misc.overview.totalSqueezedFruitsInPeriod' | transloco}}</span>
              <span *ngIf="filtersViewInLiters">{{'misc.overview.totalSqueezedLitersInPeriod' | transloco}}</span>
            </h4>
            <p-skeleton *ngIf="this.isPeriodChartInfoLoading" width="100%" height="2rem"></p-skeleton>
          </div>
          <hr>
          <app-generic-graph *ngIf="!this.isPeriodChartInfoLoading && this.squeezedValuesMeasurements" [customSeries]="false"
                             [data]="this.squeezedValuesMeasurements" [height]="350" [legend]="false"
                             [name]="'attribute.value' | transloco" chartType="line"
                             tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
                             [pointFormat]="this.tooltipFormatterPeriodInfo(this.squeezedValuesTranslationPeriodInfo)"
                             [plotOptions]="plotOptions">
          </app-generic-graph>
          <div class="w-full" *ngIf="this.isPeriodChartInfoLoading">
            <p-skeleton class="m-auto" height="350px">
            </p-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.period' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-2">
          <p-radioButton name="period" value="lastDay" [(ngModel)]="tempSelectedPeriod" id="period1"
                         (ngModelChange)="selectPeriod('lastDay')" class="mr-2"></p-radioButton>
          <label for="period1">{{ 'misc.lastDay' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="period" value="lastWeek" [(ngModel)]="tempSelectedPeriod" id="period2"
                         (ngModelChange)="selectPeriod('lastWeek')" class="mr-2"></p-radioButton>
          <label for="period2">{{ 'misc.lastWeek' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="period" value="lastMonth" [(ngModel)]="tempSelectedPeriod" id="period3"
                         (ngModelChange)="selectPeriod('lastMonth')" class="mr-2"></p-radioButton>
          <label for="period3">{{ 'misc.lastMonth' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="period" value="specificPeriod" [(ngModel)]="tempSelectedPeriod" id="period4"
                         (ngModelChange)="selectPeriod('specificPeriod')" class="mr-2"></p-radioButton>
          <label for="period4">{{ 'misc.specificPeriod' | transloco }}</label>
          <span *ngIf="this.isSpecificPeriodSelected" class="mt-auto mb-auto mr-3 ml-1"></span>
        </div>
        <div *ngIf="tempSelectedPeriod[0] === 'specificPeriod'" class="text-right mt-4">
          <p-calendar styleClass="w-full" [ngModel]="tempSpecificPeriodRange" [firstDayOfWeek]="1"
                      [showIcon]="true" [showButtonBar]="true"
                      [monthNavigator]="true" [yearNavigator]="true" [yearRange]="availableYearRange"
                      (ngModelChange)="validatePeriodRange($event)" selectionMode="range" [readonlyInput]="true"
                      inputId="range" dateFormat="dd/mm/yy" appendTo="body" [placeholder]="'select.dateRange' | transloco">
          </p-calendar>
        </div>
      </div>
    </div>
    <div *ngIf="machine?.model.machineType === 'ZITRUX'" class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.variable' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-2">
          <p-radioButton name="variable" [value]="false" [(ngModel)]="filtersViewInLitersTemp" id="variable1" class="mr-2"></p-radioButton>
          <label for="variable1">{{ 'misc.squeezedFruits' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="variable" [value]="true" [(ngModel)]="filtersViewInLitersTemp" id="variable2" class="mr-2"></p-radioButton>
          <label for="variable2">{{ 'misc.squeezedLiters' | transloco }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <p-button [label]="'common.filter' | transloco" [disabled]="(
            this.tempSelectedPeriod[0] === 'specificPeriod' && !this.isPeriodRangeValid
          )" (onClick)="filtersVisible = false; applySelection()" styleClass="p-button-primary mx-2 mt-2" type="button">
    </p-button>
    <p-button [label]="'common.clear' | transloco" (click)="resetSelection(); filtersVisible = false; applySelection()"
              styleClass="p-button-danger" type="button"></p-button>
  </div>
</p-sidebar>

<app-export-xls *ngIf="exportVisible"
                [content]="getContentExport()"
                [machineSerialNumber]="machine.serial"
                [typeContent]="'MACHINE_CHARTS'"
                [exportFileType]="exportFileType"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
